export const USER_CLOSED_TRY_NOW_MODAL = 'userClosedTryNowModal';
export const SideBarMenuClasses = {
  JOBS: 'aside__menu__secondary__item__jobs',
  PROJECTS: 'aside__menu__secondary__item__he-projects',
  WORKFLOW: 'aside__menu__secondary__item__he-workflows',
  INSIGHTS: 'aside__menu__secondary__item__he-insights',
};
